import React from "react";
import { Modal } from "@mui/material";
import styles from "./index.module.scss";
import closeIcon from "../../assets/images/close-icon.svg"
import fileIcon from "../../assets/images/Records.svg"; 
import { Button } from "../../common/components/Button";
import GrayLine from "../../common/components/GrayLine";

interface DownloadPopupProps {
  open: boolean;
  onClose: () => void;
  selected: "filtered" | "all" | null;
  setSelected: (value: "filtered" | "all") => void;
  onDownload: () => void;
}

const DownloadPopup: React.FC<DownloadPopupProps> = ({
  open,
  onClose,
  selected,
  setSelected,
  onDownload,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.popupContainer}>
        <div className={styles.header}>
          <span className={styles.title}>Download report</span>
          <GrayLine/>
          <img
            src={closeIcon}
            alt="Close"
            className={styles.closeIcon}
            onClick={onClose}
          />
        </div>
        <div className={styles.optionsContainer}>
        <div className={styles.option} onClick={() => setSelected("filtered")}>
          <input
            type="radio"
            checked={selected === "filtered"}
            readOnly
            className={styles.radio}
          />
          <span className={styles.optionText}>Current filtered list</span>
          <img src={fileIcon} alt="file" className={styles.icon} />
        </div>

        <div className={styles.option} onClick={() => setSelected("all")}>
          <input
            type="radio"
            checked={selected === "all"}
            readOnly
            className={styles.radio}
          />
          <span className={styles.optionText}>Complete registration list</span>
          <img src={fileIcon} alt="file" className={styles.icon} />
        </div>
        </div>
        <div className={styles.divider}>
        <GrayLine />
        </div>
       
        <div className={styles.footer}>
          <span className={styles.cancel} onClick={onClose}>
            cancel
          </span>
          <Button onClick={onDownload} buttonClassName={styles.downloadBtn}>
            download xlsx
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DownloadPopup;
